// extracted by mini-css-extract-plugin
export default {"feedbackBox":"FormFeedback_feedbackBox__aABzx","noMargin":"FormFeedback_noMargin__6mUp0","success":"FormFeedback_success__+tWgA","error":"FormFeedback_error__WV3Ea"};